import React, { useEffect, useRef, useState } from "react";
import CusCaptcha from "../../../CusCaptcha";
import LoaderContainer from "../../../mui/loader_container/LoaderContainer";
import ShowContainer from "../../../mui/ShowContainer";
import { API_USER } from "../../../../api/user";
import { DEBUG, ENUM_BALANCE_TYPE, TEST_MODE } from "../../../../store/enums";
import { useAppSelector } from "../../../../store/index.ts";
import { t } from "i18next";

export default function CaptchaContainer({
  methodDataPay,
  closeModal,
  setLockedInfo,
  setOpenPaymentPhone,
  setOpenPaymentCard,
  setChooseCryptogate
}) {
  const isIos = useAppSelector((state) => state.deviceSize.isIos);
  const captchaUsing = useAppSelector((state) => state.site.captchaUsing);
  const captchaRef = useRef();

  const [isLoading, setIsLoading] = useState(false);

  const isCaptcha = TEST_MODE ? true : captchaUsing[methodDataPay?.method];

  /**
   * @description - выбор нужного метода
   */
  const onCardClick = async (dataInfo) => {
    if (!dataInfo) return console.error("no payment data");
    const { amount, currency } = dataInfo;
    // setLoader(true);

    const newData = { ...dataInfo, captcha: captchaRef.current?.getValue?.() };
    await API_USER.balance
      .replenish(newData)
      .then((e) => {
        if (DEBUG) console.log("make deposit res", e);
        const data = e.data;

        if (data.depositLockInfo) setLockedInfo(data);

        if (data?.paymentUrl) {
          if (isIos) {
            window.location.href = data.paymentUrl;
          } else {
            const res = window.open(data.paymentUrl, "_blank");
            if (!res) window.location.href = data.paymentUrl;
          }

          closeModal();
        }

        const phonePayment = data.phonePayment;
        const cardPayment = data.cardPayment;

        if (phonePayment)
          setOpenPaymentPhone({ sum: phonePayment?.amount || amount, currency, ...phonePayment });
        if (cardPayment)
          setOpenPaymentCard({ sum: cardPayment?.amount || amount, currency, ...data.cardPayment });
      })
      .catch((e) => {
        if (DEBUG) console.log("make deposit cath", e);
        closeModal();
      })
      .finally(() => {
        // setLoader(false);
      });
  };

  /**
   * @description - при клике на крипту
   */
  const onCryptoCardClick = async (dataInfo) => {
    if (!dataInfo) return console.error("no payment data");

    // setLoader(true);

    const newData = { ...dataInfo, captcha: captchaRef.current?.getValue?.() };
    await API_USER.balance
      .getCryptogateAddress(newData)
      .then((e) => {
        console.log(e.data);
        const data = e.data;
        const info = {
          address: data.address,
          name: data.wallet.name,
          ticker: data.wallet.ticker
        };
        setChooseCryptogate(info);
      })
      .catch((e) => {
        console.error(e);
        closeModal();
      })
      .finally(() => {
        // setLoader(false);
      });
  };

  const paymentHandler = async () => {
    if (methodDataPay.method == ENUM_BALANCE_TYPE.fiat) {
      await onCardClick(methodDataPay.data);
    }
    if (methodDataPay.method == ENUM_BALANCE_TYPE.crypto) {
      await onCryptoCardClick(methodDataPay.data);
    }
  };

  const onCaptchaChange = async (token) => {
    if (!token) {
      console.log("Captcha reset");
      return;
    }

    setIsLoading(true);
    await paymentHandler();
    setIsLoading(false);
  };

  useEffect(() => {
    if (isCaptcha) return;
    if (TEST_MODE) return;
    console.log("paymentHandler");
    paymentHandler();
  }, [isCaptcha]);

  return (
    <ShowContainer condition={isCaptcha} plug={<LoaderContainer loader={true} center />}>
      <ShowContainer condition={isLoading}>
        <p className="captcha__container__text-await">{t("Receiving details, please wait...")}</p>
      </ShowContainer>
      <LoaderContainer center loader={isLoading}>
        <div className="captcha__container">
          <h3>{t("To get the details, please solve the captcha.")}</h3>
          <CusCaptcha onChange={onCaptchaChange} captchaRef={captchaRef} />
        </div>
      </LoaderContainer>
    </ShowContainer>
  );
}
